import { render, staticRenderFns } from "./CoshhCreateEditPage.vue?vue&type=template&id=624afb7f&"
import script from "./CoshhCreateEditPage.vue?vue&type=script&lang=js&"
export * from "./CoshhCreateEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports